__turbopack_context__.v({
  "Error": "Form-module-sass-module__yAm5eq__Error",
  "Form": "Form-module-sass-module__yAm5eq__Form",
  "FormCopy": "Form-module-sass-module__yAm5eq__FormCopy",
  "FormTitle": "Form-module-sass-module__yAm5eq__FormTitle",
  "InputField": "Form-module-sass-module__yAm5eq__InputField",
  "Required": "Form-module-sass-module__yAm5eq__Required",
  "Select": "Form-module-sass-module__yAm5eq__Select",
  "Submit": "Form-module-sass-module__yAm5eq__Submit",
  "Submitting": "Form-module-sass-module__yAm5eq__Submitting",
  "Success": "Form-module-sass-module__yAm5eq__Success",
  "Textarea": "Form-module-sass-module__yAm5eq__Textarea",
  "checkbox": "Form-module-sass-module__yAm5eq__checkbox",
  "radio": "Form-module-sass-module__yAm5eq__radio",
});
